export default {
	init() {
		$('.btn.share').on('click', function() {
			$('.share-icon').toggleClass('active')
		})

		if (!$('.comment-list').length) {
			$('.title_comments').css('display', 'none')
		}

		$('.share-icon a:not(:last-child)').on("click", function(e) {
			e.preventDefault()

			const shareLink = $(this).attr('href')

			// Set values for window
			const intWidth = '500';
			const intHeight = '400';

			// Set title and open popup with focus on it
			var strTitle = ((typeof $(this).attr('title') !== 'undefined') ? $(this).attr('title') : 'Social Share'),
				strParam = 'width=' + intWidth + ',height=' + intHeight ,
				objWindow = window.open(shareLink, strTitle, strParam).focus();
		  });
	}
}